"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NetworkClient = void 0;
const utils_1 = require("../utils");
const fetch_1 = require("./fetch");
class NetworkClient {
    constructor(fetch, messageSender, authenticationProvider, serviceUrlProvider, cacheProvider, log) {
        this.fetch = fetch;
        this.messageSender = messageSender;
        this.authenticationProvider = authenticationProvider;
        this.serviceUrlProvider = serviceUrlProvider;
        this.cacheProvider = cacheProvider;
        this.log = log;
        // Do nothing
    }
    async sendToTopic(topic, message, logAsError = "Failed to send message to SNS") {
        const r = await this.messageSender.sendToTopic(topic, message);
        if (!r) {
            throw new Error(logAsError);
        }
    }
    fireToTopic(topic, message, logAsError = "Unable to send message, error=") {
        this.logPromise(this.sendToTopic(topic, message), logAsError);
    }
    async postHttp(service, path, body, config) {
        return this.request("POST", service, path, undefined, body, config);
    }
    async putHttp(service, path, body, config) {
        return this.request("PUT", service, path, undefined, body, config);
    }
    async deleteHttp(service, path, body, config) {
        return this.request("DELETE", service, path, undefined, body, config);
    }
    async getHttp(service, path, query, config) {
        return this.request("GET", service, path, query, undefined, config);
    }
    async listHttp(service, path, query, config) {
        const { all, ...other } = config ?? { all: false };
        if (all) {
            return (0, utils_1.paginatedDownload)(async (q) => this.getHttp(service, path, q, other), query);
        }
        else {
            return this.getHttp(service, path, query, other);
        }
    }
    /**
     * Provides list all functionality for Apple Proxy endpoints
     */
    async listHttpApple(service, path, query, config, offset, limit) {
        if (config?.all) {
            return (0, utils_1.applePaginatedDownload)(async (q) => this.getHttp(service, path, q, config), query, offset, limit);
        }
        else {
            return this.getHttp(service, path, query, config);
        }
    }
    async postHttpApple(service, path, body, config, offset, limit) {
        if (config?.all) {
            return (0, utils_1.applePostPaginatedDownload)(async (b) => this.postHttp(service, path, b, config), body, offset, limit);
        }
        return this.postHttp(service, path, body, config);
    }
    async request(method, service, path, query, body, config) {
        const url = this.serviceUrlProvider.getWebServiceUrl(service, path);
        const authenticationHeaders = await this.authenticationProvider.getRequestHeaders();
        const authenticationConfig = {
            ...config,
            headers: {
                ...config?.headers,
                ...authenticationHeaders,
            },
        };
        return (0, fetch_1.fetchRequest)(this.fetch, method, url, query, body, authenticationConfig).catch((err) => {
            this.log.error(`Fetch error msg=${err.message ?? "unknown"}`);
            throw err;
        });
    }
    logPromise(promise, failureMessage = "Promise rejected with error: %s", successMessage) {
        promise
            .then(() => {
            if (successMessage) {
                this.log.debug(successMessage);
            }
        })
            .catch((err) => {
            this.log.error(`${failureMessage}: ${err ?? "Unknown"} `);
        });
    }
}
exports.NetworkClient = NetworkClient;
